import { Language } from 'dg-web-shared/lib/Localized.ts';
import { ParkingaboUserBadgeType } from 'dg-web-shared/common/models/Vehicle.tsx';
import { EmDash } from 'dg-web-shared/lib/Punctuation.ts';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';

export function getDisplayLabelForBadge(
    language: Language,
    badgeLabel: string | null,
    badgeType: ParkingaboUserBadgeType | null,
): string {
    const formattedLabel = formatBadgeLabelByType(badgeLabel, badgeType);
    if (formattedLabel && badgeType) {
        switch (badgeType) {
            case ParkingaboUserBadgeType.ParkingaboBadge:
                return `${formattedLabel} (Parkingabo)`;
            case ParkingaboUserBadgeType.ParkingpayBadge:
                return `${formattedLabel} (${parkingpayBadgeTranslation[language]})`;
        }
    }
    return EmDash;
}

export function formatBadgeLabelByType(
    badgeLabel: string | null,
    badgeType: ParkingaboUserBadgeType | null,
): string | null {
    if (badgeLabel && badgeType) {
        switch (badgeType) {
            case ParkingaboUserBadgeType.ParkingaboBadge:
                return `${badgeLabel.slice(0, 1)} ${badgeLabel.slice(1).match(/.{4}/g)?.join(' ')}`;
            case ParkingaboUserBadgeType.ParkingpayBadge:
                return `${badgeLabel.match(/.{1,3}/g)?.join(' ')}`;
        }
    }
    return null;
}

export const badgeTypeOptions = (hasApp = false, isPaymentCounter = false) => [
    {
        value: ParkingaboUserBadgeType.ParkingaboBadge,
        display: (
            <Localized
                de="Parkingabo"
                fr="Parkingabo"
                it="Parkingabo"
                en="Parkingabo"
            />
        ),
    },
    {
        value: ParkingaboUserBadgeType.ParkingpayBadge,
        display: (
            <Localized
                de="Parkingpay / Mieter"
                fr="Parkingpay / Abonnement"
                it="Parkingpay / Abbonato"
                en="Parkingpay / Tenant"
            />
        ),
        disabled: hasApp || !isPaymentCounter,
        tooltip: hasApp ? (
            <Localized
                de="Dieser Badge-Typ kann nicht mit einer Betriebsart mit App verwendet werden."
                fr="Ce badge ne peut pas être utilisé avec un mode de gestion avec app."
                it="Questo tipo di badge non può essere usato con una modalità di gestione con app."
                en="This badge type cannot be used with an app based operating mode."
            />
        ) : !isPaymentCounter ? (
            <Localized
                de="Dieser Badgetyp kann nur in einem Modus verwendet werden, in dem keine Zahlungsabwicklung vorgesehen ist."
                fr="Ce type de badge ne peut être utilisé que dans un mode où aucun paiement n'est prévu."
                it="Questo tipo di badge può essere usato solo in una modalità dove non è prevista alcuna gestione del pagamento."
                en="This type of badge can only be used in a mode where no payment processing is required."
            />
        ) : undefined,
    },
];

export const parkingpayBadgeTranslation: Record<Language, string> = {
    [Language.DE]: 'Parkingpay / Mieter',
    [Language.FR]: 'Parkingpay / Abonnement',
    [Language.IT]: 'Parkingpay / Abbonato',
    [Language.EN]: 'Parkingpay / Tenant',
};
